import { Dialog } from "primereact/dialog";
import React from "react";

function WarnMessege({ stateProps }) {
    const { setShowalert, showalert, proceedFurther, alertmessege } = stateProps;
    const footerContent = (
        <div className="text-end">
            <button
                type="button"
                className="btn btn-primary me-3"
                onClick={proceedFurther}
            >
        Proceed
            </button>
            <button
                type="button"
                className="btn btn-cancel-red"
                onClick={() => setShowalert(false)}
            >
        Cancel
            </button>
        </div>
    );
    return (
        <div>
            <Dialog
                header="Alert"
                visible={showalert}
                style={{ width: "50vw" }}
                onHide={() => {
                    setShowalert(false);
                }}
                closable={false}
                footer={footerContent}
            >
                {alertmessege}
            </Dialog>
        </div>
    );
}

export default WarnMessege;
